import apiClient from "../../services/apiClient";

// 레벨테스트는 ECHO 쪽 기록이라 우리 과제와 계통이 다르다. 학생 신원은 다른
// 학생용 API 와 같은 방식(학생id + random_code)으로 확인한다.
export async function fetchLevelTestSummaryAPI(studentId, randomCode) {
  const response = await apiClient.get(
    `/api/v1/echo/student/leveltest?student_id=${studentId}&random_code=${randomCode}`
  );
  return response.data;
}
